// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Alarm threshold values from OPC UA AlarmMonitor (LimitAlarm).
 * Contains the actual numeric threshold values.
 * @export
 * @interface UAExclusiveLimitValues
 */
export interface UAExclusiveLimitValues {
    /**
     * Critical high threshold
     */
    highHighLimit?: number;
    /**
     * Warning high threshold
     */
    highLimit?: number;
    /**
     * Warning low threshold
     */
    lowLimit?: number;
    /**
     * Critical low threshold
     */
    lowLowLimit?: number;
    /**
     * Seconds the condition must hold before the alarm fires
     */
    onDelay?: number;
    /**
     * Seconds the condition must clear before the alarm clears
     */
    offDelay?: number;
    /**
     * 
     */
    userAccessLevel?: Array<UAExclusiveLimitValuesUserAccessLevelEnum>;
}


/**
 * @export
 */
export const UAExclusiveLimitValuesUserAccessLevelEnum = {
    CurrentRead: 'currentRead',
    CurrentWrite: 'currentWrite',
    HistoryRead: 'historyRead',
    HistoryWrite: 'historyWrite',
    SemanticChange: 'semanticChange',
    StatusWrite: 'statusWrite',
    TimestampWrite: 'timestampWrite',
    Reserved: 'reserved'
} as const;
export type UAExclusiveLimitValuesUserAccessLevelEnum = typeof UAExclusiveLimitValuesUserAccessLevelEnum[keyof typeof UAExclusiveLimitValuesUserAccessLevelEnum];


/**
 * Check if a given object implements the UAExclusiveLimitValues interface.
 */
export function instanceOfUAExclusiveLimitValues(value: object): value is UAExclusiveLimitValues {
    return true;
}

export function UAExclusiveLimitValuesFromJSON(json: any): UAExclusiveLimitValues {
    return UAExclusiveLimitValuesFromJSONTyped(json, false);
}

export function UAExclusiveLimitValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAExclusiveLimitValues {
    if (json == null) {
        return json;
    }
    return {
        
        'highHighLimit': json['highHighLimit'] == null ? undefined : json['highHighLimit'],
        'highLimit': json['highLimit'] == null ? undefined : json['highLimit'],
        'lowLimit': json['lowLimit'] == null ? undefined : json['lowLimit'],
        'lowLowLimit': json['lowLowLimit'] == null ? undefined : json['lowLowLimit'],
        'onDelay': json['onDelay'] == null ? undefined : json['onDelay'],
        'offDelay': json['offDelay'] == null ? undefined : json['offDelay'],
        'userAccessLevel': json['userAccessLevel'] == null ? undefined : json['userAccessLevel'],
    };
}

export function UAExclusiveLimitValuesToJSON(json: any): UAExclusiveLimitValues {
    return UAExclusiveLimitValuesToJSONTyped(json, false);
}

export function UAExclusiveLimitValuesToJSONTyped(value?: UAExclusiveLimitValues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highHighLimit': value['highHighLimit'],
        'highLimit': value['highLimit'],
        'lowLimit': value['lowLimit'],
        'lowLowLimit': value['lowLowLimit'],
        'onDelay': value['onDelay'],
        'offDelay': value['offDelay'],
        'userAccessLevel': value['userAccessLevel'],
    };
}

